export default [{
    text: 'Включены коммунальные платежи',
    value: 'utilityCharges',
}, {
    text: 'Включены эксплуатационные расходы',
    value: 'operationalCosts',
}];
